#import "../fragments/stageset-basic.graphql"

mutation StagesetDeactivate($input: StagesetDeactivateInput!) {
    stagesetDeactivate(input: $input) {
        stageset {
            ...StagesetBasic
        }
    }
}
